import { Loader } from 'components/loader/Loader';

const FullPageLoader = () => (
  <div className='tw-py-5 tw-w-full tw-flex tw-justify-center tw-items-center tw-h-screen tw-fixed tw-top-0 tw-left-0 tw-z-50'>
    <Loader width='64px' height='64px' />
  </div>
);

export default FullPageLoader;
